import { FormAlert } from '@eggplant/pattern-library'

const RequirementGroupUpdateInfo = () =>
  <FormAlert
    title='Updating a requirement group'
    type='info'
  >
    Re-importing to an existing group replaces the requirements within the group which may result in existing requirements being updated or deleted. Deleting requirements would also permanently delete traceability to tests for these requirements.
  </FormAlert>

export default RequirementGroupUpdateInfo
